import { CssBaseline, ThemeProvider } from "@mui/material"
import { createContext, useContext, useEffect, useMemo, useState } from "react"
import { getEnvConfig } from "../config/envConfig"
import { globalStyles } from "../styles/globals"
import { buildTheme } from "../theme"

const ThemeModeContext = createContext({ toggleTheme: () => {}, mode: "light" })

export function ThemeModeProvider({ children }) {
  const initialMode = getEnvConfig().mode
  const [mode, setMode] = useState(initialMode)

  const theme = useMemo(() => buildTheme(mode), [mode])
  const toggleTheme = () => {
    setMode(prev => {
      const next = prev === "light" ? "dark" : "light"
      localStorage.setItem("app_theme_mode", next)
      return next
    })
  }

  useEffect(() => {
    const saved = localStorage.getItem("app_theme_mode")
    if (saved && saved !== mode) {
      setMode(saved)
    }
  }, [])

  return (
    <ThemeModeContext.Provider value={{ toggleTheme, mode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {globalStyles(theme)}

        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  )
}

export const useThemeMode = () => useContext(ThemeModeContext)
